import { render, staticRenderFns } from "./PatientHome.vue?vue&type=template&id=5b77763a&scoped=true"
import script from "./PatientHome.vue?vue&type=script&lang=js"
export * from "./PatientHome.vue?vue&type=script&lang=js"
import style0 from "./PatientHome.scss?vue&type=style&index=0&id=5b77763a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77763a",
  null
  
)

export default component.exports